import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Container } from '../../../ui/gridSystem';
import { HtmlRaw, Text } from '../../../ui/atoms';
import { Cover, Date } from './style';
import {
  NEWSLETTER_DETAILS_GET,
  NEWSLETTER_DETAILS_RESET,
  NEWSLETTER_GET,
} from '../../redux/actions/newsletter';
import routes from '../../../routes';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import CardNewsletter from '../../../ui/atoms/Cards/CardNewsletter';
import { CardNewsletterGrid } from '../EditProfile/style';

const NewsletterDetails = ({
  data,
  getNewsletterDetails,
  getNewsletterList,
  newsletterList,
  newsletterReset,
}) => {
  const { newsletter_id } = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getNewsletterList();
    getNewsletterDetails(newsletter_id);

    return () => newsletterReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsletter_id]);

  useEffect(() => {
    if (newsletterList?.length > 0) {
      const newList = newsletterList.filter(
        (nl) => nl?.id?.toString() !== newsletter_id
      );
      setList(newList || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsletterList]);

  const onClickCrumb = () => navigate(routes.editProfile.path);

  return (
    <>
      <Breadcrumb
        crumbs={[
          { label: 'Il mio profilo', onClick: onClickCrumb },
          { label: data?.title },
        ]}
      />
      <Container className="pt-0">
        <Text type="h1" mb={8}>
          {data?.title}
        </Text>
        {data?.subtitle && (
          <Text type="b3" mb={24}>
            {data?.subtitle}
          </Text>
        )}
        <Cover src={data?.newsletter_image} />
        {data?.sent_at && (
          <Date>
            <Text type="b4" mb={16}>
              {dayjs(data.sent_at * 1000).format('DD/MM/YYYY')}
            </Text>
          </Date>
        )}
        <Text type="b3" mb={60}>
          <HtmlRaw html={data?.body} />
        </Text>
        {list?.length > 0 && (
          <>
            <Text type="h2" mb={32}>
              Leggi le altre newsletter
            </Text>
            <CardNewsletterGrid>
              {list.slice(0, 2).map((nl, index) => (
                <CardNewsletter key={`newsletter-${index}`} item={nl} small />
              ))}
            </CardNewsletterGrid>
          </>
        )}
      </Container>
    </>
  );
};

NewsletterDetails.propTypes = {
  data: PropTypes.object,
  newsletterList: PropTypes.array,

  getNewsletterDetails: PropTypes.func,
  getNewsletterList: PropTypes.func,
  newsletterReset: PropTypes.func,
};

export default connect(
  (state) => {
    const { details: data, list: newsletterList } = state.newsletter;
    return {
      data,
      newsletterList,
    };
  },
  (dispatch) => ({
    getNewsletterDetails: (id) =>
      dispatch({ type: NEWSLETTER_DETAILS_GET._REQUEST, id }),
    getNewsletterList: () => dispatch({ type: NEWSLETTER_GET._REQUEST }),
    newsletterReset: () => dispatch({ type: NEWSLETTER_DETAILS_RESET }),
  })
)(NewsletterDetails);
